module.exports = __webpack_public_path__ + "img/2.d864a1e9.png";